import { BaseResponse, Money } from '~/sdk/shared'
import { HasRequirements } from './productTypes'
import API from '~/sdk/client'

export enum BusinessLoanType {
  Annuity = 'ANNUITY',
  Fee = 'FEE',
}

export interface Entity extends HasRequirements {
  type: 'BUSINESS_LOAN'
  enabled: boolean
  availableAmount: Money
  interest: number
  originalInterest: number
  formattedInterest: string
  formattedOriginalInterest: string
  pendingAmount: Money
  owedAmount: Money
  amortizationMethod: BusinessLoanType
  repaymentTime: number
  nextPayment: Money
  nextPaymentDate: string
  fullRepaymentAmount: Money
  termsUrl: string | null
  repayable: boolean
  availableRepaymentPeriods: number[]
  eligibleForFinancing: boolean
}

export async function get(): Promise<BaseResponse<Entity>> {
  return await API.get('internal/v2/company/products/business-loan')
}
